import { withTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import SelectWithLoader from '../../common/SelectWithLoader'

// Let the control grow to fit up to two rows of tag chips, then scroll.
// The scrollbar stays hidden until the chips area is hovered.
const tagSelectStyles = {
  control: (base) => ({
    ...base,
    height: 'auto',
    minHeight: '36px',
    alignItems: 'center'
  }),
  valueContainer: (base) => ({
    ...base,
    height: 'auto',
    maxHeight: '60px',
    padding: '3px 6px',
    gap: '4px',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&:hover': {
      scrollbarColor: '#D1D5DB transparent'
    },
    '&::-webkit-scrollbar': {
      width: '4px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
      borderRadius: '4px'
    },
    '&:hover::-webkit-scrollbar-thumb': {
      backgroundColor: '#D1D5DB'
    }
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '34px'
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0
  }),
  multiValue: (base) => ({
    ...base,
    margin: 0,
    height: '22px',
    alignItems: 'center',
    maxWidth: '120px',
    minWidth: 0
  }),
  multiValueLabel: (base) => ({
    ...base,
    padding: 0,
    paddingLeft: 0,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }),
  multiValueRemove: (base) => ({
    ...base,
    padding: 0,
    marginLeft: '4px',
    borderRadius: '50%',
    flexShrink: 0
  })
}

const TagSelect = ({ options, value, onChange }) => {
  return (
    <div className='select'>
      <label className='select__label'>Tags</label>
      <SelectWithLoader
        isSearchable
        isMulti
        defaultValue={options.length === 1 ? options[0] : undefined}
        value={value}
        options={options}
        showIndicatorSeparator={false}
        styles={tagSelectStyles}
        onChange={onChange}
      />
    </div>
  )
}
export default withTranslation()(
  observer(TagSelect)
)
